export default __webpack_public_path__ + "static/media/printKit.5c09c6c4.png";